import React, { useState, useRef, useEffect } from 'react';

export const Info_intro = ({ redactNFt }) => {
  return (
    <>
      <span style={{ fontSize: '25px' }}>O</span>ver a year in the making,{' '}
      <em>TODEM (Tapestry of Decadent Meritocracy)</em> is a colossal
      AI-generated GIF that unfolds like an animated tapestry, navigable via a
      map-style interface. Harnessing generative AI for industrial-scale content
      production, it explores themes of polarity, amorality, and meritocracy,
      while investigating new frontiers for AI and blockchain in art.
      <br></br>
      <br></br>
      At 100K x 58K pixels (~2800 HD screens or 5800 megapixels) and 100 frames,
      <i>TODEM</i> may be the largest animation ever created.
      <br></br>
      <br></br>
      <h5>Process & AI</h5>
      <div className="info-line-container">
        <span className="info-line"></span>
      </div>
      With custom-built rendering system, interface, and
      minting platform, alongside the latest AI text & image synthesis, <i>TODEM</i> serves as both an ode to and critique of 21st century distributions of
      wealth, attention, and dignity. The use of generative AI to create such
      vast animation is a technical necessity, as well as a crucial aspect of
      the project's meaning.
      <br></br>
      <br></br>
      While we have completely shaped the work, both aesthetically and
      conceptually, neural network models generated the precise details,
      resulting in content and juxtapositions ranging from charming and
      hilarious to the truly bizarre and deeply uncomfortable. 5226 subtile
      prompts yielded 14hrs 31min of total animation and, although we've made a
      genuine effort, manually inspecting this volume of text and imagery is
      challenging for a small team.
      <br></br>
      <br></br>Current AI's natively amoral posture is both interesting and
      problematic for us, adding another layer to the work. No subtile text or
      pixel was composed by hand, and no offense is intended by any specific
      imagery or prompt. We are in control of contours, texture, and affect —
      autonomous software authored specific details with outcomes influenced by
      bounded probabilities. Think of this aspect as descended from Mad Libs,
      Exquisite Corpse, and Musikalisches Würfelspiel. We hope that, even with
      the occasionally difficult content, John Cage would approve.
      <br></br>
      <br></br>
      As in some previous projects, we expect future work will continue to
      emphasize bounded local indeterminacy (little infinities) with direct
      authorship sited in guiding the larger-scale form and distribution of
      experience. It is interesting to imagine the brilliant 21st century
      artists whose genius will lie in the aesthetics of probability.
      <br></br>
      <br></br>
      <h5>Scale, Tiles & Blockchain</h5>
      <div className="info-line-container">
        <span className="info-line"></span>
      </div>
      The GIF decomposes into 1000 unique Tiles, each mintable on the Ethereum
      blockchain. The Tiles themselves contain numerous subtiles whose content
      is derived via the celebrity & meritocracy of the top 5226
      English-language Wikipedia pages (by pageview).
      <br></br>
      <br></br>The size of the Tiles mirrors the distribution of wealth in the
      United States. The 10 largest (Class A) occupy over 30% of total pixel
      area, while the smallest 500 (Class D) claim just 3% of the pixels.
      Perhaps surprisingly, we've embraced the blockchain to make individual
      Tiles available for acquisition as NFTs. Interesting timing from us,
      possibly, but at least there are no empty-calorie abstractions or monkey
      pics (ok, there's one).
      <br></br>
      <br></br>
      With cost based per-pixel, mint prices are perversely broad - many are
      tiny and economical (less than $1.00!), while a few are rare and huge.
      This unconventional pricing structure is also an integral facet of the
      work's meaning and intention.
      <br></br>
      <br></br>
      Proceeds from Class A (10%) and Class B (5%) Tile minting are
      automatically routed to a charity wallet aimed at supporting structural
      reforms in the US. We are particularly interested in Rank Choice Voting
      variants to address polarities in the electoral process.
      <br></br>
      <br></br>
    </>
  );
};

export default Info_intro;
